import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO-компонент для Яндекс и Google
 * @param {string} title - Заголовок страницы (до 60 символов)
 * @param {string} description - Описание (до 160 символов)
 * @param {string} [keywords] - Ключевые слова через запятую (необязательно)
 * @param {string} [props.canonicalUrl] - Канонический URL для избежания дублирования контента
 */
const SeoHelmet = ({
                                title,
                                description,
                                keywords,
                                canonicalUrl,
                                jsonLd
                            }) => {
    // Обрезаем строки до рекомендуемой длины
    const optimizedTitle = title.length > 60 ? `${title.substring(0, 57)}...` : title;
    const optimizedDesc = description.length > 160 ? `${description.substring(0, 157)}...` : description;

    const baseUrl = 'https://www.sespel.su';
    // Canonical должен присутствовать для каждого публичного маршрута.
    const rawPath = canonicalUrl || window.location.pathname;
    const canonicalPath = rawPath === '/' ? '/' : rawPath.replace(/\/+$/, '');
    const fullCanonicalUrl = /^https?:\/\//i.test(canonicalPath)
        ? canonicalPath
        : `${baseUrl}${canonicalPath.startsWith('/') ? '' : '/'}${canonicalPath}`;

    return (
        <Helmet prioritizeSeoTags>
            {/* Основные теги */}
            <title>{optimizedTitle}</title>
            <meta name="description" content={optimizedDesc} />
            {keywords && <meta name="keywords" content={keywords} />}

            {/* Robots */}
            <meta name="robots" content="index, follow" />
            <meta name="googlebot" content="index, follow" />
            <link rel="icon" href="/favicon.svg" type="image/svg+xml"/>

            {/* Каноническая ссылка */}
            {fullCanonicalUrl && <link rel="canonical" href={fullCanonicalUrl} />}
            {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
        </Helmet>
    );
};

export default SeoHelmet;